import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { ClientFaqListResource } from 'app/models/ClientFaqListResource';
import { UtilsService } from 'app/services/utils.service';
import { DragulaService } from 'ng2-dragula';
import { forkJoin, Subscription } from 'rxjs';

@Component({
  selector: 'vbn-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  faqs: ClientFaqListResource;
  errorMessage: any;
  userEmail: string;
  subscription: Subscription;
  items: any;

  constructor(private service: UtilsService, 
    private router: Router, 
    private _notificationService: NotificationsService,
    private translate: TranslateService,
    private dragula: DragulaService) { 

      this.faqs = new ClientFaqListResource();
      this.faqs.list = [];
      this.subscription = this.dragula.drop.subscribe(value => {
        this.changeOrderIndex(value);
      });
    }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.geFaqsForUser();
  }

  geFaqsForUser(): void{
    this.service.get(`/admin/clientFaq/getAll?userEmail=${this.userEmail}`)
    .subscribe(
      response => {
       this.faqs = response;
       if(this.faqs.errorCode === 11150){
        this.faqs = new ClientFaqListResource();
        this.faqs.list = [];
       }
      },
      error => this.errorMessage = <any>error);
  }

  changeOrderIndex(value: any){
    let rid = value[1].getAttribute("faq-rid")
    let oldPos = parseInt(value[1].getAttribute("index"))
    let newPos = undefined
    let departmentList = value[2].children;

    for (let i = 0; i < departmentList.length; i++) {
      let k = departmentList[i].getAttribute("faq-rid")
      if (rid == k) {
        newPos = i
        break;
      }
    }

    this.service.add(`/admin/clientFaq/shift?oldPosition=${oldPos}&newPosition=${newPos}&userEmail=${this.userEmail}`,null)
    .subscribe(
      response => {
       this.faqs = response;
       if(this.faqs.errorCode === 11156){
          forkJoin(
            [this.translate.get('Chance Order error'),
            this.translate.get('The order was not changed')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
          })
       }else{
          forkJoin(
            [this.translate.get('Success'),
            this.translate.get('FAQ order was changed!')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
       }
       this.geFaqsForUser();
      },
      error => this.errorMessage = <any>error);

    setTimeout(() => {
      console.log('------');
    }, 1000);
  }


  delete(rid) {
    this.service.get(`/admin/clientFaq/delete/${rid}?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          if([11154, 11155, 10984].indexOf(response.errorCode) > 0){
            forkJoin(
              [this.translate.get('Delete error'),
              this.translate.get(`The faq was not deleted (${response.errorCode})`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          }else{
            forkJoin(
              [this.translate.get('Success'),
              this.translate.get('Faq was deleted!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            })
          }
          this.geFaqsForUser();
        },
        error => this.errorMessage = <any>error);
  }

  edit(rid) {
    this.router.navigate(['/edit-client-faq/' + btoa('{ "faqRid" : "' + rid + '"}')]);
  }

}
